export default __webpack_public_path__ + "static/media/rest3.4426969a.jpg";